import RoutesConfig from './routesConfig';

export default RoutesConfig;
